/**
 * Backlog の課題キーから、その課題の画面の URL を作る。
 *
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business Backlog の課題キー（AIRCLOSET-123）から、Backlog の課題画面へのリンクを組み立てる
 * @graph-connects none
 */
export function backlogUrl(key: string): string {
  return `https://air-closet.backlog.jp/view/${key}`;
}
